import { render, staticRenderFns } from "./GraficosProdutos.vue?vue&type=template&id=814368a4"
import script from "./GraficosProdutos.vue?vue&type=script&lang=js"
export * from "./GraficosProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports